import React from 'react';
import config from 'config';

const Multinav = () => {
    
    const urlLibrary = config.multinavScript;
    const brand = "HON";
    const dxpGuid = localStorage.getItem('user.DxpGuid');

    if(dxpGuid !== null && dxpGuid !== ''){
        if(!document.getElementById("MultiNavScript")){
            AddScript(urlLibrary, brand, dxpGuid);
        }
    }

    return (
        <></>
    );
}

 function AddScript(urlLibrary, brand, dxpGuid) {
    const script = document.createElement("script");
    script.src = urlLibrary;
    script.setAttribute("id", "MultiNavScript")
    
    script.onload = function(){
        window.AddHNIHeader(brand, dxpGuid);
    }  
    
    document.body.appendChild(script);
}

export default Multinav;